// import './guests-ajax.js';
import './modal.js';
import './global.js';
import './visit.js';
import './users.js';
import './mob-nav.js';
import './datatable.js';

import './all-visits-datatable.js';
import './today-visits-datatable.js';
import './settings-datatable.js';
import './guests-datatable.js';
import './onsitenow-datatable.js';
import './user-history-datatable.js';


import './alert.js';
import './filter.js';
import './settings.js';
import './guests.js';
import './file-upload.js';





// WEBPACK FOOTER //
// ./main.js